export const skeletonToyBatonTestId = "pages/index/banners/Skeleton-ToyBaton";
export const bannerToyBatonTestId = "pages/index/banners/Banner-ToyBaton";
export const bannerLineTestId = "pages/index/banners/Banner-Line";
export const bannerInviteTestId = "pages/index/banners/Banner-Invite";
export const bannerToysubStoreTestId = "pages/index/banners/Banner-ToysubStore";
export const mamabBigCampaignTestId = "pages/index/banners/Banner-mamabBigCampaign";
export const calldoctorCampaignTestId = "pages/indesx/banners/Banner-calldoctorCampaign";
